module.exports = __webpack_public_path__ + "assets/icon-arrow-down-component.b2f693db.svg";